export default "__VITE_ASSET__599ae1ee__"